var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23636 8.00008C5.23636 6.49823 6.50301 5.33341 7.99898 5.33341C9.49495 5.33341 10.7616 6.49823 10.7616 8.00008C10.7616 9.50194 9.49495 10.6667 7.99898 10.6667C6.50301 10.6667 5.23636 9.50194 5.23636 8.00008ZM7.99898 6.66675C7.17982 6.66675 6.56969 7.2928 6.56969 8.00008C6.56969 8.70736 7.17982 9.33341 7.99898 9.33341C8.81814 9.33341 9.42826 8.70737 9.42826 8.00008C9.42826 7.2928 8.81814 6.66675 7.99898 6.66675Z",
    fill: "#687386"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.699466 7.79162C1.68245 4.80524 4.59193 2.66675 7.99937 2.66675C11.4068 2.66675 14.3163 4.80527 15.2993 7.79167L15.3679 8.00011L15.2993 8.20854C14.3163 11.1949 11.4068 13.3334 7.99939 13.3334C4.59193 13.3334 1.68243 11.1949 0.699464 8.20849L0.630859 8.00006L0.699466 7.79162ZM2.03905 8.00006C2.90183 10.3164 5.23254 12.0001 7.99939 12.0001C10.7662 12.0001 13.0969 10.3164 13.9597 8.0001C13.0969 5.68376 10.7662 4.00008 7.99937 4.00008C5.23254 4.00008 2.90184 5.68373 2.03905 8.00006Z",
    fill: "#687386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d5de19cd2638037d60b26ba259acb6c0.svg";
export { ForwardRef as ReactComponent };